<template>
  <div class="account-settings-info-view">
    <a-form layout="vertical" :form="form">
      <a-form-item
        label="真实姓名"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input placeholder="请输入真实姓名" v-decorator="['realname']" />
        <!-- <a-input
          :disabled="!awardId"
          placeholder="请输入真实姓名"
          v-model="userInfo.realname"
        /> -->
      </a-form-item>
      <a-form-item
        label="证件号码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          placeholder="证件号码"
          v-decorator="['idcard']"
        />
        <!-- <a-input :disabled="!awardId" placeholder="证件号码" v-model="userInfo.idcard" /> -->
      </a-form-item>
      <!-- <a-form-item>
        <a-button type="primary" @click="handleSubmitIdcard">修改身份信息</a-button>
      </a-form-item> -->
      <!-- <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <j-upload
          v-decorator="['avatar']"
          :uploadTarget="'qiniu'"
          :fileType="'image'"
          :number="1"
          :trigger-change="true"
        ></j-upload>
      </a-form-item> -->
      <a-form-item label="证件照" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-row>
          <a-col :xs="24" :md="12">
            <!-- <j-upload
              v-decorator="['photo', validatorRules.photo]"
              :uploadTarget="'qiniu'"
              :fileType="'image'"
              :number="1"
              :maxFileSize="5"
              :trigger-change="true"
              @selected="photoChange"
            ></j-upload> -->
            <div class="ant-upload-preview" @click="$refs.photoModal.edit(1)">
              <a-icon type="cloud-upload-o" class="upload-icon" />
              <div class="mask">
                <a-icon type="plus" />
              </div>
              <img v-if="userInfo" :src="userInfo.photo_url" />
            </div>
          </a-col>
          <a-col :xs="24" :md="12" class="photo-example">
            <a-tag color="blue">蓝底一寸免冠照</a-tag>
            <a-tag color="orange">文件5MB以内</a-tag>
            <img
              width="180"
              src="../../assets/photo-example.png"
              alt="示例照片"
            />
            <h2 class="tips">示例照片</h2>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="年级" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <j-dict-select-tag
          v-decorator="['grade', validatorRules.grade]"
          :trigger-change="true"
          dictCode="grade"
          placeholder="请选择年级"
        />
      </a-form-item>
      <!-- <a-form-item label="生日" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          style="width: 100%"
          placeholder="请选择生日"
          v-decorator="[
            'birthday',
            {
              initialValue: !userInfo.birthday
                ? null
                : moment(userInfo.birthday, dateFormat),
            },
          ]"
        />
      </a-form-item> -->

      <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-radio-group v-decorator="['sex', validatorRules.sex]">
          <a-radio-button :value="1"> 男 </a-radio-button>
          <a-radio-button :value="2"> 女 </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入邮箱"
          v-decorator="['email', validatorRules.email]"
        />
      </a-form-item>
      <a-form-item
        v-if="false"
        label="连接密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :required="false"
      >
        <a-input placeholder="h3gSbecd" />
      </a-form-item>
      <a-form-item
        v-if="false"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="登录密码"
        :required="false"
      >
        <a-input placeholder="密码" />
      </a-form-item>

      <a-form-item
        label="手机号码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          placeholder="请输入手机号码"
          v-decorator="['phone', validatorRules.phone]"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSubmit">修改资料</a-button>
        <a-divider v-if="userModifyList" type="vertical"></a-divider>
        <a-button v-if="userModifyList" @click="modifyModalVisible=true">信息更正查看</a-button>
      </a-form-item>
    </a-form>
    <a-modal title="信息更正申请" v-model="modifyModalVisible" :width="300" :footer="null">
      <div v-for="(item, index) in userModifyList" :key="index">
        <p>状态：
          <a-tag v-if="item.status==0" color="blue">审核中</a-tag>
          <a-tag v-if="item.status==-1" color="red">审核不通过</a-tag>
        </p>
        <p>姓名：{{item.realname}}</p>
        <p>身份证：{{item.idcard}}</p>
        <a-divider></a-divider>
        <p>照片：</p>
        <img v-if="item.photo_url" width="180" :src="item.photo_url"/>
      </div>
      <a-divider></a-divider>
    </a-modal>
    <PhotoModal ref="photoModal" @ok="photoChange"></PhotoModal>
  </div>
</template>

<script>
import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import PhotoModal from "@/components/user/PhotoModal";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import moment from "moment";
import pick from "lodash.pick";
import { getAction, putAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import store from "@/store/";

const token = Vue.ls.get(ACCESS_TOKEN);
export default {
  components: {
    PhotoModal,
    JDictSelectTag,
    JUpload,
  },
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: { "X-Access-Token": token },
      form: this.$form.createForm(this),
      validatorRules: {
        realname: { rules: [{ required: true, message: "请输入用户名称!" }] },
        grade: {
          rules: [{ required: true, message: "请输入年级!" }],
        },
        photo: {
          rules: [{ required: true, message: "请上传证件照!" }],
        },
        phone: {
          rules: [
            { required: true, message: "请填写手机号!" },
            { validator: this.validatePhone },
          ],
        },
        sex: {
          initialValue: 1,
          rules: [{ required: true, message: "请选择性别!" }],
        },
        email: {
          rules: [
            {
              required: true,
              pattern:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: "请输入正确的邮箱地址!",
            },
          ],
        },
      },
      userInfo: {},
      modifyModalVisible: false,
      userModifyList: [],
      url: {
        userInfo: "/teaching/user/info",
        userHonor: "/teaching/teachingUserHonor/userHonor",
        editUser: "/teaching/user/edit",
        modifyUser: "/sys/sysUserModify/modify",
      },
      realname: "",
      idcard: "",
      awardId: null,
    };
  },
  computed: {},
  created() {
    this.getUserInfo();
    this.getModifyApply();
    this.awardId = this.$route.query.awardId;
  },
  methods: {
    moment,
    getModifyApply() {
      getAction("/sys/sysUserModify/myModifyApply").then((res) => {
        if (res.success && res.result) {
          this.userModifyList  = res.result
          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i].status == -1) {
              this.$info({
                title: "提示",
                content: "照片审核不通过，请重新上传",
                onOk() {},
              });
            }
          }
        }
      });
    },
    //同步用户信息
    getUserInfo() {
      var that = this;
      getAction(this.url.userInfo).then((res) => {
        if (res.success) {
          that.userInfo = res.result;
          that.$nextTick(() => {
            that.form.setFieldsValue(
              pick(
                that.userInfo,
                "username",
                "idcard",
                "sex",
                "realname",
                "email",
                "photo",
                "grade",
                "phone",
                "avatar"
              )
            );
          });
          store.commit("SET_NAME", {
            username: that.userInfo.username,
            realname: that.userInfo.realname,
          });
          store.commit("SET_AVATAR", that.userInfo.avatar_url);
          store.commit("SET_USER_INFO", that.userInfo);
        }
      });
    },
    handleSubmit() {
      const that = this;
      var values = that.form.getFieldsValue();
      console.log(values);
      that.confirmLoading = true;
      if (!values.birthday) {
        values.birthday = "";
      } else {
        values.birthday = values.birthday.format(this.dateFormat);
      }
      let formData = Object.assign(this.userInfo, values);
      console.log(formData);
      // that.addDepartsToUser(that,formData); // 调用根据当前用户添加部门信息的方法
      //putAction(that.url.editUser, formData)
      putAction(this.url.modifyUser, formData)
        .then((res) => {
          if (res.success) {
            that.getUserInfo();
            that.$message.success(res.message);
            that.$emit("ok");
            if (res.message == "提交申请成功") {
              this.$info({
                title: "提示",
                content: "修改身份证和姓名将在3个工作日内审核完毕",
                onOk() {},
              });
            }
          } else {
            that.$message.warning(res.message);
          }
        })
        .finally(() => {
          that.confirmLoading = false;
        });
    },
    // handleSubmitIdcard(){
    //   putAction(this.url.modifyUser, {
    //     id: this.userInfo.id,
    //     realname: this.userInfo.realname,
    //     idcard: this.userInfo.idcard
    //   }).then((res) => {
    //       if (res.success) {
    //         this.getUserInfo();
    //         this.$info({
    //           title: "提示",
    //           content: "将在3个工作日内审核完毕",
    //           onOk() {},
    //         });
    //       } else {
    //         this.$message.warning(res.message);
    //       }
    //     })
    //     .finally(() => {
    //       this.confirmLoading = false;
    //     });
    // },
    photoChange(key, photoId) {
      putAction(this.url.modifyUser, {
        id: this.userInfo.id,
        photo: photoId,
        awardId: this.awardId,
      })
        .then((res) => {
          if (res.success) {
            this.getUserInfo();
            this.$info({
              title: "提示",
              content: "修改证件照将在3个工作日内审核完毕",
              onOk() {},
            });
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    validatePhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^1[3456789]\d{9}$/).test(value)) {
          var params = {
            tableName: "sys_user",
            fieldName: "phone",
            fieldVal: value,
            dataId: this.userId,
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback();
            } else {
              callback("手机号已存在!");
            }
          });
        } else {
          callback("请输入正确格式的手机号码!");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 280px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 200px;
  height: 280px;
  box-shadow: 0 0 4px #ccc;
  .upload-icon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;
    &:hover {
      opacity: 1;
    }
    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }
  img,
  .mask {
    width: 100%;
    max-width: 200px;
    height: 100%;
    overflow: hidden;
  }
}

.photo-example {
  text-align: center;
  img {
    margin-top: 10px;
  }
  .tips {
    position: relative;
    top: -200px;
    color: white;
    font-weight: 600;
    font-size: 30px;
    line-height: 0;
  }
}
</style>